import { userSpecificationFormToQuery as formToQuery } from "./userSpecificationFormToQuery";
import { userSpecificationQueryToForm as queryToForm } from "./userSpecificationQueryToForm";

export default { formToQuery, queryToForm };
